// Files without `permissions` (v3 feed rows) rely on the caller's gate
export function getIsFileRemovable(file) {
  return file?.permissions?.can_delete !== false
}
